<template>
    <div class="modal fade" 
        :class="this.modalPosition" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

        <div class="np-base-dialog modal-dialog modal modal-dialog-centered w-100" :class="modalClass">
                <div class="modal-content shadow p-3">
                    <div class="modal-header border-0 p-4 pb-2">
                        <span class="col-sm-8 d-flex align-middle">
                            <svg class="icon"><use href="@/assets/images/icons/info.svg#icon"></use></svg>
                            {{ $t("UI.task.progressTitle") }}
                        </span>
                    </div>

                    <div class="modal-body">
                        <div class="np-panel px-4 mx-4">
                            <div class="np-panel-body">
                                <span class="np-f-bold pt-2">{{ $t("UI.task.taskProgress") }}</span>
                                <span class="np-font-xl mb-4" :class="colorStyle">{{ progress }}%</span>
                                <div class="pb-4 mb-4">
                                    <vue-slider 
                                        v-model="progress" 
                                        :marks="marks" 
                                        :contained="true" 
                                        :tooltip="'none'"
                                        :rail-style="{ height: '6px', backgroundColor: '#E7EBEF' }"
                                        :process-style="{ backgroundColor: '#C3CDD8' }"
                                    >
                                        <template v-slot:dot="{ value, focus }">
                                            <div :class="['progress-custom-dot', { focus }]"></div>
                                        </template>                                        
                                        <template v-slot:label="{ label, active }">
                                            <div :class="['vue-slider-mark-label', 'custom-label', { active }]">{{ label }}</div>
                                        </template>
                                        <template v-slot:step="{ label, active }">
                                            <div :class="['progress-custom-step', { active }]"></div>
                                        </template>                                        
                                    </vue-slider>   
                                </div>      
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer np-borderless p-3">
                        <button type="button" class="np-btn np-success-filled px-4 np-flex-1" @click="save()">
                            {{ $t("UI.task.updateTaskProgress") }}
                        </button>
                    </div>                    
                </div>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import { Modal } from "bootstrap"
import { ref } from 'vue'

export default {
    components: {
        VueSlider
    },
    props: {
        modalID: {
            type: String,
            required: true
        },        
        modalSize: {
            type: String,
            default: ''
        },
        modalPosition: {
            type: String,
            default: ''
        },
        progressColors: {
            type: Array,
            default: []
        }      
    }, 
    data() {
        return {  
            progress: 0,
            marks: val => val % 10 === 0
        }
    },    
    computed: {     
        colorStyle() {
            if (this.progress < 30) {
                return 'np-color-danger'
            } else if (this.progress < 75) {
                return 'np-color-warning'
            } else {
                return 'np-color-success'
            }
        } 
    },
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})
    },           
    methods: {
        shows(_progress) {
            this.progress = _progress

            this.theModal.show()
        },
        hide() {
            this.theModal.hide()
        },
        async close() {
            this.$emit('closeModal')
        },
        async save() {
            await this.$emit('setProgress', this.progress)
            this.hide()
        }, 
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
    .progress-custom-dot {
        width: 38px;
        height: 28px;
        background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAzOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNyIgaGVpZ2h0PSIyNyIgcng9IjkuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzU3NzQ5MyIvPgo8cmVjdCB4PSIxMyIgeT0iMTkiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxIiByeD0iMC41IiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgMTMgMTkpIiBmaWxsPSIjNDA1QjdDIi8+CjxyZWN0IHg9IjE4IiB5PSIxOSIgd2lkdGg9IjEwIiBoZWlnaHQ9IjEiIHJ4PSIwLjUiIHRyYW5zZm9ybT0icm90YXRlKC05MCAxOCAxOSkiIGZpbGw9IiM0MDVCN0MiLz4KPHJlY3QgeD0iMjMiIHk9IjE5IiB3aWR0aD0iMTAiIGhlaWdodD0iMSIgcng9IjAuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDIzIDE5KSIgZmlsbD0iIzQwNUI3QyIvPgo8L3N2Zz4=') no-repeat center;
        background-size: contain;
        margin-top: -7px;
        margin-left: -12px;
    }    
    .progress-custom-step {
        height: 100%;
        width: 1px;
        background-color: var(--color-primary-500);
    }
</style>